<template>
  <div>
    <div v-if="data.advanceSale || data.preSaleDesc" class="delivery">
      <img
        :src="
          union_isBilingual || CookiesOne && CookiesOne == 'en-US'
            ? require('@/assets/images/productDetail/pre-tag-en.png')
            : require('@/assets/images/productDetail/pre-tag.png')
        "
        alt=""
        :class="['pre-tag']"
        :style="{ marginLeft: union_isBilingual ? '-10px' : '' }"
      />
      
      <span v-if="data.preSaleDesc">{{data.preSaleDesc}}</span>
      <span v-else>
        {{
          `${TLang('现在下单','list')}，${new Date(data.sendGoodsTimeStart)
            .toLocaleDateString()
            .replace(/\//g, "-")}${TLang('起开始发货','list')}`
        }}
      </span>
    </div>
    <!-- <div
      v-else-if="
        data.deliveryWay === '3' && !data.advanceSale && data.cutOffTimeStr
      "
      class="delivery"
    >
      <img :src="require('@/assets/images/productDetail/trunk.png')" alt="" />
      <span>
        {{
          new Date().getHours() < data.cutOffTimeStr.split(":")[0]
            ? `${data.cutOffTimeStr}前（含${data.cutOffTimeStr})下单，可选今日发货`
            : `${data.cutOffTimeStr}后下单，可选次日起发货`
        }}
      </span>
    </div> -->
  </div>
</template>
<script>
import Cookies from 'js-cookie';
export default {
  name: "OldHtmlSkuPickerPart",
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.delivery {
  line-height: 30px;
  margin-left: 42px;
  margin-bottom: 10px;
  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
  img.pre-tag {
    width: 36px;
    height: 20px;
  }
  span {
    font-size: 14px;
    color: #666;
  }
}
</style>
